export default __webpack_public_path__ + "static/media/pic9.4d8d4e18.jpg";